import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export const downloadReceiptPDF = (receipt) => {
  const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
  const w = 210;
  const margin = 20;
  const col = margin;
  let y = margin;

  const formatCurrency = (cents) => `$${(cents / 100).toFixed(2)}`;
  const formatDate = (val) => {
    if (!val) return '';
    const d = val.toDate ? val.toDate() : new Date(val);
    return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  };

  // Header bar
  pdf.setFillColor(30, 30, 30);
  pdf.rect(0, 0, w, 18, 'F');
  pdf.setFont('helvetica', 'bold');
  pdf.setFontSize(13);
  pdf.setTextColor(255, 255, 255);
  pdf.text('PEBBLE', margin, 12);
  pdf.setFont('helvetica', 'normal');
  pdf.setFontSize(8);
  pdf.text('Event Marketplace', margin, 16.5);
  y = 30;

  // Title + meta
  pdf.setTextColor(20, 20, 20);
  pdf.setFont('helvetica', 'bold');
  pdf.setFontSize(18);
  pdf.text('Receipt', col, y);
  y += 7;
  pdf.setFont('helvetica', 'normal');
  pdf.setFontSize(8.5);
  pdf.setTextColor(120, 120, 120);
  pdf.text(`#${receipt.transactionId || '—'}`, col, y);
  pdf.text(formatDate(receipt.createdAt), w - margin, y, { align: 'right' });
  y += 10;

  // Divider
  pdf.setDrawColor(220, 220, 220);
  pdf.line(margin, y, w - margin, y);
  y += 8;

  // From / To
  pdf.setFontSize(8);
  pdf.setTextColor(130, 130, 130);
  pdf.setFont('helvetica', 'bold');
  pdf.text('FROM', col, y);
  pdf.text('TO', w / 2 + 5, y);
  y += 5;
  pdf.setFont('helvetica', 'bold');
  pdf.setFontSize(10);
  pdf.setTextColor(20, 20, 20);
  pdf.text(receipt.mpsBusinessName || '—', col, y);
  pdf.text(receipt.eoName || '—', w / 2 + 5, y);
  y += 5;
  pdf.setFont('helvetica', 'normal');
  pdf.setFontSize(8.5);
  pdf.setTextColor(100, 100, 100);
  pdf.text(receipt.mpsEmail || '', col, y);
  pdf.text(`Event: ${receipt.eventName || '—'}`, w / 2 + 5, y);
  y += 12;

  // Divider
  pdf.setDrawColor(220, 220, 220);
  pdf.line(margin, y, w - margin, y);
  y += 8;

  // Payment breakdown
  pdf.setFont('helvetica', 'bold');
  pdf.setFontSize(8);
  pdf.setTextColor(130, 130, 130);
  pdf.text('PAYMENT BREAKDOWN', col, y);
  y += 6;

  const row = (label, value, color = [20, 20, 20]) => {
    pdf.setFont('helvetica', 'normal');
    pdf.setFontSize(9.5);
    pdf.setTextColor(...color);
    pdf.text(label, col, y);
    pdf.text(value, w - margin, y, { align: 'right' });
    y += 6;
  };

  row('Vendor Registration Fee', formatCurrency(receipt.totalAmount));
  row('Pebble Service Fee (15%)', `- ${formatCurrency(receipt.platformFee)}`, [180, 60, 60]);
  y += 1;
  pdf.setDrawColor(200, 200, 200);
  pdf.line(margin, y, w - margin, y);
  y += 5;
  pdf.setFont('helvetica', 'bold');
  pdf.setFontSize(10);
  pdf.setTextColor(20, 20, 20);
  pdf.text('Event Organizer Receives', col, y);
  pdf.text(formatCurrency(receipt.eoAmount), w - margin, y, { align: 'right' });
  y += 14;

  // Footer
  pdf.setDrawColor(220, 220, 220);
  pdf.line(margin, y, w - margin, y);
  y += 6;
  pdf.setFont('helvetica', 'normal');
  pdf.setFontSize(8);
  pdf.setTextColor(150, 150, 150);
  pdf.text('Thank you for your business!', w / 2, y, { align: 'center' });
  y += 5;
  pdf.text(`Transaction ID: ${receipt.paymentIntentId || '—'}`, w / 2, y, { align: 'center' });

  pdf.save(`receipt-${receipt.transactionId || receipt.id}.pdf`);
};

export const exportReceiptToPDF = async (elementId, fileName = 'receipt.pdf') => {
  try {
    const element = document.getElementById(elementId);
    if (!element) {
      throw new Error('Element not found');
    }

    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      backgroundColor: '#ffffff',
    });

    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4',
    });

    const imgWidth = 210;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);

    pdf.save(fileName);
    return { success: true };
  } catch (error) {
    console.error('Error exporting PDF:', error);
    return { success: false, message: error.message };
  }
};

export const printReceipt = (elementId) => {
  try {
    const element = document.getElementById(elementId);
    if (!element) {
      throw new Error('Element not found');
    }

    const printWindow = window.open('', '', 'width=800,height=600');
    printWindow.document.write(element.innerHTML);
    printWindow.document.close();
    printWindow.print();
  } catch (error) {
    console.error('Error printing receipt:', error);
  }
};
